module.exports = __webpack_public_path__ + "static/media/lejos.d8a373aa.png";